export default __webpack_public_path__ + "static/media/guides.091bace5.svg";